// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// SocialPlatform — source: shared/config/social_platforms.config.json

export const SOCIAL_PLATFORM_VALUES = ["linkedin", "instagram", "facebook", "x", "pinterest"] as const;
export type SocialPlatform = (typeof SOCIAL_PLATFORM_VALUES)[number];

export const socialPlatformLabel: Record<SocialPlatform, string> = {
  "linkedin": "LinkedIn",
  "instagram": "Instagram",
  "facebook": "Facebook",
  "x": "X",
  "pinterest": "Pinterest",
};

export const socialPlatformColor: Record<SocialPlatform, string> = {
  "linkedin": "#0A66C2",
  "instagram": "#E4405F",
  "facebook": "#1877F2",
  "x": "#0F1419",
  "pinterest": "#BD081C",
};

export const socialPlatformIcon: Record<SocialPlatform, string> = {
  "linkedin": "Linkedin",
  "instagram": "Instagram",
  "facebook": "Facebook",
  "x": "XBrand",
  "pinterest": "Pinterest",
};

export const socialPlatformDarkColor: Record<SocialPlatform, "#70B5F9" | "#F17A8F" | "#6BA8F7" | "#E7E9EA" | "#E8607A"> = {
  "linkedin": "#70B5F9",
  "instagram": "#F17A8F",
  "facebook": "#6BA8F7",
  "x": "#E7E9EA",
  "pinterest": "#E8607A",
};

export const socialPlatformUrlPrefix: Record<SocialPlatform, "https://linkedin.com/in/" | "https://instagram.com/" | "https://facebook.com/" | "https://x.com/" | "https://pinterest.com/"> = {
  "linkedin": "https://linkedin.com/in/",
  "instagram": "https://instagram.com/",
  "facebook": "https://facebook.com/",
  "x": "https://x.com/",
  "pinterest": "https://pinterest.com/",
};

export const socialPlatformSearchEndpoint: Record<SocialPlatform, "/api/v1/integrations/google/search/social/linkedin" | "" | "/api/v1/integrations/google/search/social/twitter"> = {
  "linkedin": "/api/v1/integrations/google/search/social/linkedin",
  "instagram": "",
  "facebook": "",
  "x": "/api/v1/integrations/google/search/social/twitter",
  "pinterest": "",
};

